import { DepartmentInterface } from "./../../common/interfaces/department.interface"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { PagingState } from "../../common/interfaces/pagingParam.interface"
import { SearchConditionState } from "../../common/interfaces/searchConditionParam"
import { SortConditionInterface } from "../../common/interfaces/sortCondition.interface"
import { SortColumnEnum } from "../../common/enum/sortColumn.enum"
import { SortOrderEnum } from "../../common/enum/sortOrder.enum"
import { handleSortOrder } from "../../common/helper/sortTable.helper"
import { FilterTableEnum } from "../../common/enum/filterTable.enum"

export interface DepartmentState {
   requesting: boolean
   successful: boolean
   error: string
   data: DepartmentInterface[]
   rowCount: number
   paging: PagingState
   searchCondition: SearchConditionState
   sortCondition: SortConditionInterface
}

const initialState: DepartmentState = {
   requesting: false,
   successful: false,
   error: "",
   data: [],
   rowCount: 0,
   paging: {
      pageNumber: 1,
      pageSize: 10,
   },
   searchCondition: {
      option: FilterTableEnum.NONE,
      value: "",
   },
   sortCondition: {
      column: SortColumnEnum.NONE,
      order: SortOrderEnum.ASC,
   },
}

export const departmentSlice = createSlice({
   name: "department",
   initialState,
   reducers: {
      requestDepartments: (state: DepartmentState) => {
         state.requesting = true
      },
      getDepartmentsSuccess: (
         state: DepartmentState,
         action: PayloadAction<any>
      ) => {
         state.requesting = false
         state.successful = true
         state.error = ""
         state.data = action.payload.data
         state.rowCount = action.payload.rowCount
      },
      getDepartmentsFail: (
         state: DepartmentState,
         action: PayloadAction<any>
      ) => {
         state.requesting = false
         state.successful = false
         state.error = action.payload
         state.data = []
      },
      changePageNumberSuccess: (
         state: DepartmentState,
         action: PayloadAction<number>
      ) => {
         state.paging.pageNumber = action.payload
      },
      changePageSizeSuccess: (
         state: DepartmentState,
         action: PayloadAction<number>
      ) => {
         state.paging.pageNumber = 1
         state.paging.pageSize = action.payload
      },
      changeSearchConditionSuccess: (
         state: DepartmentState,
         action: PayloadAction<any>
      ) => {
         state.paging.pageNumber = 1
         state.searchCondition.option = action.payload.option
         state.searchCondition.value = action.payload.value
      },
      changeSortConditionSuccess: (
         state: DepartmentState,
         action: PayloadAction<any>
      ) => {
         state.sortCondition.order = handleSortOrder(
            state.sortCondition.column,
            action.payload.column,
            state.sortCondition.order
         )
         state.sortCondition.column = action.payload.column
      },
   },
})

export const {
   requestDepartments,
   getDepartmentsSuccess,
   getDepartmentsFail,
   changePageNumberSuccess,
   changePageSizeSuccess,
   changeSearchConditionSuccess,
   changeSortConditionSuccess,
} = departmentSlice.actions

export default departmentSlice.reducer
